export function loadFfmpeg() {
    return window.ffmpeg;
}
